export interface IAdobeDTM {
	trackState: Partial<
		{
			"page.name": string;
			"page.type": string;
			"page.subType": string;
			"page.viewType": string;
			"page.viewSubType": string;
		} & unknown &
			Record<string, string | number | Date>
	>;
	trackAction: Partial<
		{
			"action.name": string;
			"action.element.text": string;
			"action.element.index": number;
			"action.element.targetUrl": string;
		} & unknown &
			Record<string, string | number | Date>
	> &
		Required<{
			"page.name": string;
		}>;
}

export abstract class AdobeDTM {
	public static trackState(params: IAdobeDTM["trackState"]) {
		console.log(params);
		try {
			const pageName = params["page.name"] || ("" as string);
			window.history.pushState(params, pageName);

			const fakeURL = pageName
				.split(":")
				.slice(2)
				.map((it) => {
					return it.trim().split(" ").join("_");
				})
				.join("/");

			window.dataLayer.push({
				event: "virtualPageview",
				pageUrl: fakeURL,
				pageTitle: pageName,
			});

			window._satellite?.track("trackState", params);
		} catch (e) {
			console.log(e);
		}
	}

	public static trackAction(params: IAdobeDTM["trackAction"]) {
		console.log(params);
		try {
			window._satellite?.track("trackAction", params);
		} catch (e) {
			console.log(e);
		}
	}

	public static appendParamsToLink(location: string, isNative: boolean) {
		try {
			const url = new URL(window._satellite.getVisitorId().appendVisitorIDsTo(location));
			const satelliteSid = window._satellite?.cookie.get("rsid");

			const rSid = isNative
				? process.env.REACT_APP_NATIVE_RSID
				: process.env.REACT_APP_WEB_RSID;
			const sid = satelliteSid || rSid;

			if (sid) {
				url.searchParams.append("rsid", sid);
			}

			return url.toString();
		} catch (e) {
			console.log(e);
		}

		return location;
	}
}
